import React from "react";
import { Link } from "react-router-dom";

const CtaStrip = () => (
  <section className="cta-strip">
    <div className="cta-strip__inner">
      <div>
        <h2>Ready to streamline your operations?</h2>
        <p>Book a free 30-minute walkthrough with our team.</p>
      </div>
      <Link to="/contact" className="btn-primary btn-primary--inverse">
        Request a Demo
      </Link>
    </div>
  </section>
);

export default CtaStrip;
